import { lazy } from 'react';

export const ReferallSettingsPageLazy = lazy(() => import('./ReferallSettingsPage'));
